import { IRoute } from "@src/routes";
import CreateProgramPage from "./pages/CreateProgramPage";
import EditProgramPage from "./pages/EditProgramPage";
import ListProgramPage from "./pages/ListProgramPage";
import RegisterLoadCPF from "./pages/RegisterLoadCPF";
import RegisterLoadCPFResult from "./pages/RegisterLoadCPFResult";
import RegisterLoadCNPJ from "./pages/RegisterLoadCNPJ";
import RegisterLoadCNPJResult from "./pages/RegisterLoadCNPJResult";
import ListProgramPriority from "./pages/ListProgramPriority";
import RegisterCleanCPF from "./pages/RegisterCleanCPF";
import RegisterCleanCPFResult from "./pages/RegisterCleanCPFResult";
import RegisterLoadProductGroupRules from "./pages/RegisterLoadProductGroupRules";
import RegisterLoadProductGroupRulesResult from "./pages/RegisterLoadProductGroupRulesResult";

import { SsoRolesEnum } from "@funcional/react-auth-ui";

const routes: IRoute[] = [
  {
    menu: { label: "Novo Programa" },
    path: "/pbm/programs/new",
    key: "PBM_PROGRAM_CREATE",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: CreateProgramPage,
  },
  {
    path: "/pbm/programs/:programCode/edit",
    key: "PBM_PROGRAM_EDIT",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: EditProgramPage,
  },
  {
    menu: {
      label: "Regras",
    },
    path: "/pbm/programs",
    key: "PBM_LIST",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
    ],
    component: ListProgramPage,
  },
  {
    path: "/pbm/programs/:programCode/loadcpf",
    key: "PBM_PROGRAM_REGISTER_LOAD_CPF",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: RegisterLoadCPF,
  },
  {
    path: "/pbm/programs/:programCode/loadcpf/confirm/:result",
    key: "PBM_PROGRAM_REGISTER_LOAD_CPF_RESULT",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: RegisterLoadCPFResult,
  },
  {
    path: "/pbm/programs/:programCode/cleancpf",
    key: "PBM_PROGRAM_REGISTER_UNLOAD_CPF",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: RegisterCleanCPF,
  },
  {
    path: "/pbm/programs/:programCode/cleancpf/confirm/:result",
    key: "PBM_PROGRAM_REGISTER_UNLOAD_CPF_RESULT",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: RegisterCleanCPFResult,
  },

  {
    path: "/pbm/programs/:programCode/loadcnpj",
    key: "PBM_PROGRAM_REGISTER_LOAD_CNPJ",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: RegisterLoadCNPJ,
  },
  {
    path: "/pbm/programs/:programCode/loadcnpj/confirm/:result",
    key: "PBM_PROGRAM_REGISTER_LOAD_CNPJ_RESULT",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
    ],
    component: RegisterLoadCNPJResult,
  },
  {
    path: "/pbm/programs/:programCode/loadproductgrouprules",
    key: "PBM_PROGRAM_REGISTER_LOAD_PRODUCT_GROUP_RULES",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
    ],
    component: RegisterLoadProductGroupRules,
  },
  {
    path: "/pbm/programs/:programCode/loadproductgrouprules/confirm/:result",
    key: "PBM_PROGRAM_REGISTER_LOAD_PRODUCT_GROUP_RULES_RESULT",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
    ],
    component: RegisterLoadProductGroupRulesResult,
  },

  {
    path: "/pbm/programs/:establishmentIdentity/priority",
    key: "PBM_LIST_PRIORITY",
    exact: true,
    roles: [
      SsoRolesEnum.MASTER,
      SsoRolesEnum.SUPPORT,
      SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
      SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
    ],
    component: ListProgramPriority,
  },
];

export default routes;
